import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TimeInterface } from 'shared/interface';
import { handleRemoveOverflow, msToHMS } from 'shared/util/utility';
import './styles.scss';

interface Props {
	sessionStart: number;
}

const SessionTimer: FC<Props> = ({ sessionStart }) => {
	const { t } = useTranslation();
	const [sessionTime, setSessionTime] = useState(msToHMS(new Date().getTime() - sessionStart));

	useEffect(() => {
		const sessionTimeInterval = setInterval(() => setSessionTime(msToHMS(new Date().getTime() - sessionStart)), 1000);
		return () => {
			handleRemoveOverflow();
			clearInterval(sessionTimeInterval);
		};
	}, [sessionStart]);

	return (
		<div style={{ opacity: '0.5' }} className="SessionTimer">
			<span className="SessionTimer__text">{t('currentSession')}</span>
			<span className="SessionTimer__time">
				{sessionTime.map((time: TimeInterface) => `${time.hours} godz. ${time.minutes} min. ${time.seconds} sek.`)}
			</span>
		</div>
	);
};

export default SessionTimer;
